<template>
  <div class="grid">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "Grid"
};
</script>
<style>
/* < XS */

:root {
  --SHOW-SIZES: none;

  --SPACE-BOTTOM-x1: calc(var(--LINE-HEIGHT) * 1);
  --SPACE-BOTTOM-x2: calc(var(--LINE-HEIGHT) * 2);
  --SPACE-BOTTOM-x5: calc(var(--LINE-HEIGHT) * 4);

  --PADDING: 20px;
}

@media only screen and (max-width: 576px) {
  :root {
    --SPACE-LEFT: 25px;
    --SPACE-RIGHT: 25px;
    --WIDTH: 100%;
    --COLUMN-SIZE: 25%;
    --EXTRA-SPACE-LEFT: 0;

    --SPACE-BOTTOM-x5: calc(var(--LINE-HEIGHT) * 2);
  }

  .grid:after {
    display: var(--SHOW-SIZES);
    position: fixed;
    top: 10px;
    left: 10px;
    content: "<XS :1";
  }
}

/* XS */

@media only screen and (min-width: 576px) and (max-width: 767px) {
  :root {
    --SPACE-LEFT: 25px;
    --SPACE-RIGHT: 25px;
    --WIDTH: 100%;
    --COLUMN-SIZE: 25%;
    --EXTRA-SPACE-LEFT: 0px;
  }

  .grid:after {
    display: var(--SHOW-SIZES);
    content: "XS :2";
    position: fixed;
    top: 10px;
    left: 10px;
  }
}

/* S */

@media only screen and (min-width: 767px) and (max-width: 992px) {
  :root {
    --SPACE-LEFT: 25px;
    --SPACE-RIGHT: 0px;
    --WIDTH: 768px;
    --COLUMN-SIZE: 12.5%;
    --EXTRA-SPACE-LEFT: 0px;
  }

  .grid:after {
    display: var(--SHOW-SIZES);
    content: "S :3";
    position: fixed;
    top: 10px;
    left: 10px;
  }
}

/* M  */

@media only screen and (min-width: 992px) {
  :root {
    --SPACE-LEFT: 50px;
    --SPACE-RIGHT: 0px;
    --WIDTH: 992px;
    --COLUMN-SIZE: 12.5%;
    --EXTRA-SPACE-LEFT: 20px;
  }
  .grid:after {
    display: var(--SHOW-SIZES);
    content: "M :4";
    position: fixed;
    top: 10px;
    left: 10px;
  }
}

.grid {
  margin-left: var(--SPACE-LEFT);
  margin-right: var(--SPACE-RIGHT);
  width: calc(var(--WIDTH) - var(--SPACE-LEFT) - var(--SPACE-RIGHT));
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;
}

.grid:after {
  position: absolute;
}

.grid-column {
  box-sizing: border-box;
  flex-grow: 0;
  /* border-right: 2px solid pink; */
}

.grid-column.x1 {
  width: var(--COLUMN-SIZE);
}
.grid-column.x2 {
  width: calc(var(--COLUMN-SIZE) * 2);
}
.grid-column.x3 {
  width: calc(var(--COLUMN-SIZE) * 3);
}
.grid-column.x4 {
  width: calc(var(--COLUMN-SIZE) * 4);
}
.grid-column.x5 {
  width: calc(var(--COLUMN-SIZE) * 5);
}
.grid-column.x6 {
  width: calc(var(--COLUMN-SIZE) * 6);
}
.grid-column.x7 {
  width: calc(var(--COLUMN-SIZE) * 7);
}
.grid-column.x8 {
  width: calc(var(--COLUMN-SIZE) * 8);
}

@media only screen and (max-width: 576px) {
  .grid-column.x4x8 {
    width: calc(var(--COLUMN-SIZE) * 4);
  }

  .grid-column.shrinkTo4 {
    width: calc(var(--COLUMN-SIZE) * 4);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .grid-column.x4x8 {
    width: calc(var(--COLUMN-SIZE) * 4);
  }
  .grid-column.shrinkTo4 {
    width: calc(var(--COLUMN-SIZE) * 4);
  }
}
@media only screen and (min-width: 767px) and (max-width: 992px) {
  .grid-column.x4x8 {
    width: calc(var(--COLUMN-SIZE) * 8);
  }
}
@media only screen and (min-width: 992px) {
  .grid-column.x4x8 {
    width: calc(var(--COLUMN-SIZE) * 8);
  }
}

/*
@media only screen and (max-width: 576px) { }
@media only screen and (min-width: 576px) and (max-width: 767px) {}
@media only screen and (min-width: 768px) and (max-width: 992px) {}
@media only screen and (min-width: 992px) {}
*/
</style>



// WEBPACK FOOTER //
// src/components/Grid.vue